
import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from "react-i18next";

import AboutAuth from '../../UI/AboutAuth';
import Backdrop from '../../Backdrop/Backdrop';
import Modal from '../../Modal/Modal';
import FilesUploadAction from '../../FileUploadAction/FilesUploadAction';

import { useStore } from '../../../hook-store/store';
import { textToFile } from '../../../utils/text-util';

import { marks } from '../../../utils/marks';
import './TextToText.css';


const TextToTextFile = (props) => {
  const { 
    replacedText,
   } = props;

  const [t] = useTranslation("translation");
  
  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  const [responseTextFile, setResponseTextFile] = useState();
  const [fileTextContent, setFileTextContent] = useState('');
  const [showUploadModal, setShowUploadModal] = useState(false);

  useEffect(() => {
    if (replacedText) {
      createTextFileHandler(replacedText);
    }
  },[replacedText]);


  const createTextFileHandler = (text) => {
      const textFile = textToFile(text, `textVoiceAssistant-${Date.now()}`);
      // console.log(textFile)
      setResponseTextFile(textFile);

      getFileTextHandler(textFile);
  };

  const getFileTextHandler = async (file) => {
    try {
      const fileUrl = URL.createObjectURL(file);

      const response = await fetch(fileUrl);

      const resData = await response.text();

      if (resData) {
        setFileTextContent(resData);
      }

      // console.log(response, resData);

    } catch(err) {
      console.log(err);
    }
  }


  let displayText = fileTextContent;

  if (fileTextContent && fileTextContent.length > 100) {
    displayText = fileTextContent.slice(0, 100) + '....';
  }

  let fileUploadModalBody;

  if (showUploadModal) {
    fileUploadModalBody = (
      <div>
        <Backdrop 
          zIndex={'95'}
          onCancel={() => { 
            setShowUploadModal(false);
          }}
        />
        <Modal
          onClose={() => {
            setShowUploadModal(false);
          }}
        >
          <div>
            <div className='transcriberUploadSection'>
              <div className='transcriberUploadTitle'>
                Upload to Kura Storage
              </div>
            </div>
            <div className='transcriberUploadSection'>
              <div>text content</div>
  
              <div className='transcriberUploadText'
                // style={{border: "1px solid red" ,whiteSpace: "pre-wrap"}}
              >
                {displayText} 
              </div>
            </div>
            <br/>
  
            {isAuth && (
              <div className='transcriberUploadSection'>
                <FilesUploadAction 
                  uploadFiles={[responseTextFile]}
                  uploadApp={'textVoiceAssistant'}
                />
              </div>
            )}
            {!isAuth && (
              <div className='transcriberUploadSection'>
                <AboutAuth />
              </div>
            )}
          </div>
        </Modal>
      </div>
    )
  }

  return (
    <Fragment>
      <div>
        <div>
          <button className='btnBase'
            onClick={() => {
              setShowUploadModal(true);
            }}
          >
            {marks.fileTextOMark} Upload text as text file {marks.uploadMark}
          </button>
        </div>
        
        <div>
          {fileUploadModalBody}
        </div>
      </div>
    </Fragment>
  );
};

export default TextToTextFile;